import { Saletype } from "@/models/App";
import type { Order } from "@/models/Order";
import { computed, ref } from "vue";

const order = ref<Order>();

const useOrderDetail = () => {
  const setOrder = (newProduct: Order) => {
    order.value = newProduct;
  };

  const reset = () => {
    order.value = undefined;
  };

  const clickAndCollectLink = computed(() => {
    if (order.value?.saleType !== Saletype.CLICK_AND_COLLECT) return "";
    const host = window.location.hostname;
    const protocol = window.location.protocol + "//";
    const port = window.location.port ? `:${window.location.port}` : "";
    return `${protocol}${host}${port}/clickAndCollect/#/ritira?orderId=${order.value.id}`;
  });

  return {
    order,
    clickAndCollectLink,
    setOrder,
    reset
  };
};

export default useOrderDetail;
